import styled from "styled-components";

export const DashboardContainer = styled.div`
 background: #f3f7ff;
  margin-left: 255px;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: hidden;

  @media (max-width: 768px) {
    margin-left: 0px;
  }

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

export const DashboardWrapper = styled.div`
  display: flex;
  z-index: 1;
  height: 91vh;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  overflow: overlay;
`;

export const DashboardHeading = styled.div`
  padding: 1rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;

  @media screen and (max-width: 768px) {
    padding: 0.8rem;
    margin-top: 0.4rem;
  }

  @media screen and (max-width: 480px) {
    margin-top: 0.2rem;
    padding: 0.5rem;
  }

  @media screen and (max-width: 320px) {
    margin-top: 0rem;
    padding: 0rem 0rem;
  }
`;

export const DashHeading = styled.div`
  color: #000;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 32.023px;
  letter-spacing: 0.8px;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }

  @media screen and (max-width: 480px) {
    font-size: 12px;
  }
`;

export const ProfileDetailForm = styled.div`
  width: 100%;
  padding: 1rem;
`;

export const InputDivide = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Button = styled.button`
  width:fit-content;
  height: 39px;
  padding:0.5rem 2rem;
  border-radius: 4px;
  background: #5088FB;
  color: #FFFFFF;
  border: none;
  outline: none;
`;

export const CancelButton = styled.button`
  width:fit-content;
  height: 39px;
  padding:0.5rem 2rem;
  border-radius: 4px;
  background: #FFFFFF;
  color: #26344E;
  border: 1px solid #26344E38
`;